/* eslint-disable no-param-reassign */

// TODO: 该转换逻辑未来需要消化掉
export function assetsTransform(assets) {
  var components = assets.components,
    packages = assets.packages;
  var packageMaps = (packages || []).reduce(function (acc, cur) {
    var key = cur.id || cur["package"] || '';
    acc[key] = cur;
    return acc;
  }, {});
  components.forEach(function (componentDesc) {
    var devMode = componentDesc.devMode,
      schema = componentDesc.schema,
      reference = componentDesc.reference;
    if (devMode === 'lowcode') {
      devMode = 'lowCode';
    } else if (devMode === 'proCode') {
      devMode = 'proCode';
    }
    if (devMode) {
      componentDesc.devMode = devMode;
    }
    if (devMode === 'lowCode' && !schema && reference) {
      var referenceId = reference.id || '';
      componentDesc.schema = packageMaps[referenceId].schema;
    }
  });
  return assets;
}